/*  ========================================================================
    # Sections - Posts - Index
    ========================================================================  */

import React from 'react';
import { createRoot, type Container } from 'react-dom/client';
import Posts from './Posts';

export type PostsProps = {
  headline: string;
  layout: 'all' | 'category' | 'selected';
  selectedCategory: number | false;
  selectedPosts: number[] | null;
  allCategories: Array<{
    term_id: number;
    name: string;
    slug: string;
    term_group: number;
    term_taxonomy_id: number;
    taxonomy: string;
    description: string;
    parent: number;
    count: number;
    filter: string;
    cat_ID: number;
    category_count: number;
    category_description: string;
    cat_name: string;
    category_nicename: string;
    category_parent: number;
  }>;
};

const containers = document.querySelectorAll('div[data-react-app="posts"]');

for (let i = 0; i < containers.length; i++) {
  const containerGuid = (containers[i]?.attributes as any)['data-guid']?.value;
  const props = (window as any).reactProps[containerGuid] as PostsProps;

  createRoot(containers[i] as Container).render(<Posts {...props} />);
}
